import { createSlice } from "@reduxjs/toolkit";

export const pensionSlice = createSlice({
  name: "pensionTime",
  initialState: {
    timeCount: 0,
  },
  reducers: {
    addTime: (state, action) => {
      state.timeCount += action.payload;
    },
    resetTime: (state) => {
      state.timeCount = 0;
    },
  },
});

export const { addTime, resetTime } = pensionSlice.actions;

export default pensionSlice.reducer;
